import type { DivisionJob } from '../hooks/useSchedulerGeneration'

export interface TimeoutRetryTarget {
  divisionId: string
  gamesPerTeam: number
}

/**
 * Collect the reduced per-team targets to apply before retrying after a
 * fail-soft SOLVER_TIMEOUT (SN-7897 gate #5).
 *
 * A retry re-runs ALL failed divisions at once, so EVERY timed-out division
 * that carries a `recommended_games_per_team` must be included. Applying only
 * the first one (the prior `.find()` behaviour) left the remaining timed-out
 * divisions to time out again on retry.
 */
export function collectTimeoutRetryTargets(
  jobs: DivisionJob[] | undefined | null
): TimeoutRetryTarget[] {
  return (jobs ?? [])
    .filter(
      (j) =>
        j.status === 'failed' &&
        j.error_code === 'SOLVER_TIMEOUT' &&
        j.recommended_games_per_team != null
    )
    .map((j) => ({
      divisionId: j.division_id,
      gamesPerTeam: j.recommended_games_per_team as number,
    }))
}
